import React, { useEffect, useContext } from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import ResponsiveDrawer from '../components/ResponsiveDrawer';
import { features } from 'config';
import { FirebaseContext } from 'common';
import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core';
import audio from 'assets/audio/alert-canceled-booking.mp3';

function matchUser(permit, usertype) {
    let permitions = permit ? permit.split(',') : [];
    let permitted = false;
    for (let i = 0; i < permitions.length; i++) {
        permitted = usertype === permitions[i] ? true : false
        if (permitted) break;
    }
    return permitted;
}

function ProtectedRoute({ component: Component, permit, ...rest }) {
    const auth = useSelector(state => state.auth);
    const routeLocation = useLocation();
    const { api } = useContext(FirebaseContext);
    const dispatch = useDispatch();
    const {
        signOut,
        fetchAvailableDrivers,
        fetchActiveBookingsFilter,
        signOutUser
    } = api;
    const logoutTime = 1000 * 60 * 60 * 4;
    let timeout = null;

    /* navigator.connection.addEventListener('change', (event) => {
        
        console.log('Change Network', event);
        window.location.reload();
    }); */

    useEffect(() => {
        if ( auth.info) {
            const updateStateDriversAndBookings = () => {
                console.log('Actualización de Drivers Activos y Bookings Activos');
                dispatch(fetchActiveBookingsFilter('NEW'));
                dispatch(fetchAvailableDrivers());
            };
    
    
            updateStateDriversAndBookings();
    
            const intervalId = setInterval(() => {
                updateStateDriversAndBookings();
            }, 30 * 60 * 1000); // 30 minutos en milisegundos
    
            // Limpiar el intervalo al desmontar el componente
            return () => clearInterval(intervalId);
        }
    }, [auth]);

    useEffect(() => {
        console.log('Pathname', routeLocation.pathname);

        restartInactivitySignOut();

        window.addEventListener('mousemove', onMouseMove);

        return () => {
            if (timeout) {
                clearTimeout(timeout);
                window.removeEventListener('mousemove', onMouseMove);
            }
        };
    }, [routeLocation.pathname]);

    const restartInactivitySignOut = () => {
        if (timeout) {
            clearTimeout(timeout);
        }

        timeout = setTimeout(() => {
            alert('Session terminated due to inactivity');
            dispatch(signOutUser());
        }, logoutTime);
    };

    const onMouseMove = () => {
        restartInactivitySignOut();
    };

    console.log('Render protected router');

    return (
        <Route {...rest} render={props => (
            auth.info && auth?.info?.profile && matchUser(permit, auth?.info?.profile.usertype) ?
                <ResponsiveDrawer><Component {...props} /></ResponsiveDrawer>
                : features.WebsitePagesEnabled ? <Redirect to="/login" /> : <Redirect to="/" />
        )} />
    )
}

export default ProtectedRoute;